import React, { useEffect, useRef, useState } from 'react';
import { Settings, Moon, Sun, Monitor, Check } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeProvider';

const THEME_LABELS = {
  light:    { label: 'Ljus',     Icon: Sun },
  dark:     { label: 'Mörk',     Icon: Moon },
  contrast: { label: 'Kontrast', Icon: Monitor },
};

export function SidebarFooter({ onOpenSettings }) {
  const { theme, setTheme, themes } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    });
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  }, [menuOpen]);

  const ActiveIcon = THEME_LABELS[theme]?.Icon || Sun;

  return (
    <div className="kp-sidebar-footer" ref={menuRef}>
      <button
        type="button"
        className="kp-settings-btn"
        onClick={onOpenSettings}
        aria-label="Öppna inställningar"
      >
        <Settings size={15} strokeWidth={2} aria-hidden="true" />
        <span>Inställningar</span>
      </button>
      <button
        type="button"
        className="kp-theme-toggle"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="Byt tema"
        aria-haspopup="menu"
        aria-expanded={menuOpen}
      >
        <ActiveIcon size={15} strokeWidth={2} aria-hidden="true" />
      </button>
      {menuOpen ? (
        <div className="kp-theme-menu" role="menu">
          {themes.map((t) => {
            const meta = THEME_LABELS[t];
            const Icon = meta.Icon;
            const isActive = t === theme;
            return (
              <button
                key={t}
                type="button"
                className={`kp-theme-menu-item${isActive ? ' kp-theme-menu-item--active' : ''}`}
                onClick={() => {
                  setTheme(t);
                  setMenuOpen(false);
                }}
                role="menuitemradio"
                aria-checked={isActive}
              >
                <Icon size={14} strokeWidth={2} aria-hidden="true" />
                <span>{meta.label}</span>
                {isActive ? <Check className="kp-theme-menu-item-check" size={14} aria-hidden="true" /> : null}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
